import { components } from "@appretio/api";

/**
 * All the available context fields that can be requested
 */
export type ContextField =
  | components["schemas"]["ContextFieldV2"]
  | keyof components["schemas"]["ForecastContextOptions-Input"]
  | "source"
  | "gender";

export type ContextSelectedOptions =
  components["schemas"]["ContextOptionsV2Input"]["filters"];

export type ForecastContextSelectedOptions =
  components["schemas"]["ForecastContextOptionsInput"]["filters"];

/**
 * Represents a single context option as displayed in the
 * context selector dropdowns
 */
interface ContextOption {
  displayName: string;
  displayOrder: number;
}

/**
 * Mapping between available context fields and display name and orders
 */
export const contextOptions: Record<ContextField, ContextOption> = {
  brand: { displayName: "Brand", displayOrder: 1 },
  sub_brand: { displayName: "Sub-brand", displayOrder: 2 },
  product_line: { displayName: "Product line", displayOrder: 3 },
  collection_type: { displayName: "Col type", displayOrder: 4 },
  product_category: { displayName: "Product Category", displayOrder: 5 },
  collection_name: { displayName: "Collection", displayOrder: 6 },
  country: { displayName: "Country", displayOrder: 7 },
  sales_location: { displayName: "Location", displayOrder: 8 },
  stock_location: { displayName: "Stock location", displayOrder: 10 },
  chain: { displayName: "Chain", displayOrder: 11 },
  channel: { displayName: "Channel", displayOrder: 12 },
  collection_season_name: { displayName: "Seasonality", displayOrder: 13 },
  markdown_status: { displayName: "Markdown", displayOrder: 14 },
  source: { displayName: "Source", displayOrder: 15 },
  gender: { displayName: "Gender", displayOrder: 16 }
};
